<template lang="html">
  <div>
    <Layout currentMenu="Account" subMenu="Post Management" :fullScreenLoading="saving">
      <LoadingSection :loading="loading" title="Post Management" :autoPadding="false">
        <template v-slot:content>
          <div class="">
            <select class="select input" v-model="articleType" @change="reload">
              <option value="Blog">Blog</option>
              <option value="Press">Press</option>
            </select>
          </div>

          <div class="gap-3x" />
          <SymbiumButton
            text="New Post"
            :onClick="openNewPostModal"
            :isSmall="true"
          />
          <draggable
            v-model="articles"
            draggable=".draggable-section"
            @end="updateArticlesOrder"
          >
            <div class="draggable-section" v-for="article in articles" :key="article.id">
              <div class="gap-3x" />
              <div class="line-break" />
              <div class="gap-3x" />
              <div>
                <div class="edit-link cursor-pointer" @click="() => openEditPostModal(article)">
                  {{article.subject}} - {{article.status}}
                </div>
              </div>
            </div>
          </draggable>
        </template>
      </LoadingSection>
    </Layout>
    <ConfirmModal />
    <EditPostModal @updated="reload" @destroy="openDestroyConfirm" />
  </div>
</template>

<script>
import Draggable from 'vuedraggable'

import Layout from 'src/components/dashboard/shares/Layout.vue'
import LoadingSection from 'src/components/dashboard/shares/LoadingSection.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import ConfirmModal from "src/components/common/modals/ConfirmModal.vue";

import EditPostModal from './modals/EditPostModal.vue'
import ArticleSortable from './mixins/ArticleSortable.js'

export default {
  components: {
    SymbiumButton, ConfirmModal, EditPostModal, Layout, LoadingSection, Draggable
  },
  mixins: [ArticleSortable],
  data() {
    return {
      articleType: 'Blog',
    }
  },
  methods: {
    openNewPostModal() {
      this.$modal.show('edit-post-modal', { article: { type: this.articleType, data: {}, statuses: ['published', 'draft'], status: 'draft' }, config: { disabled: 'disabled' } })
    },
    openEditPostModal(article) {
      this.$modal.show('edit-post-modal', { article })
    },
  },
}
</script>

<style lang="scss">
.posts-list {
  .posts-list-group {
    padding: 24px;

    input {
      width: 100%;
    }

    .label {
      margin-bottom: 8px;
    }

    .form-group {
      margin-bottom: 0;
    }

    .posts-list-field {
      margin-left: 48px;
    }

    div {
      flex: 1;
    }
  }
}

@media screen and (max-width: 768px) {
  .posts-list {
    .posts-list-group {
      display: block;

      .posts-list-field {
        margin: 0;
      }
    }
  }
}
</style>
